import React, { useState, useRef, useContext } from "react";
import { isEmpty, callApi, serializeObject, spaceCheck } from "bodycodi/cmap/app/js/common";

import { StateContext, DispatchContext } from "bodycodi/cmap/app/components/common/context";
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import PopupHeader from "bodycodi/cmap/app/components/common/popupHeader";
import { Input } from "bodycodi/cmap/app/components/cmap1010/input";
import FindPasswordCompletePop from "./findPasswordComplete";

type ChangePasswordPop = {
  update: Function;
};

function ChangePasswordPop({ update }: ChangePasswordPop) {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CHANGE_PASSWORD_POP1",
      open: { changePasswordPop1: false },
    });
  };

  return (
    <CustomDialog open={state.changePasswordPop1} onClose={handleClose}>
      {state.changePasswordPop1 && <ChangePasswordWrap update={update} onClose={handleClose} />}
    </CustomDialog>
  );
}

type ChangePasswordWrap = {
  update: Function;
  onClose: () => void;
};

function ChangePasswordWrap({ update, onClose }: ChangePasswordWrap) {
  return (
    <>
      <PopupHeader title="비밀번호 재설정" onClickBack={onClose} />
      <ChangePassword update={update} onClose={onClose} />
    </>
  );
}

type ChangePassword = {
  update: Function;
  onClose: Function;
};

function ChangePassword({ update, onClose }: ChangePassword) {
  const { dispatch } = useContext(DispatchContext);
  const newPassword = useRef<HTMLInputElement>(null);
  const newPasswordConfirm = useRef<HTMLInputElement>(null);
  const [newValText, setNewValText] = useState("");
  const [newValTextConfirm, setNewValTextConfirm] = useState("");
  const [succesText, setSuccesText] = useState("");
  const [passwordCrtf, setPasswordCrtf] = useState(false);
  const [name, setName] = useState<string>("");

  const checkPassword = () => {
    const newVal = newPassword.current!.value;
    const newValConfirm = newPasswordConfirm.current!.value;

    if (isEmpty(newVal)) {
      setNewValText("새 비밀번호를 입력해 주세요.");
      return;
    } else if (spaceCheck(newVal)) {
      setNewValText("새 비밀번호 앞뒤에 공백이 들어갈수 없습니다.");
      return;
    } else if (!checkMixEngNum(newVal) || newVal.length < 8) {
      setNewValText("영문, 숫자 포함 8글자 이상 입력해주세요.");
      return;
    } else if (newVal != newValConfirm) {
      setNewValTextConfirm("새 비밀번호와 동일하지 않습니다.");
      setSuccesText("");
      setPasswordCrtf(false);
      return false;
    } else {
      setNewValText("");
      setNewValTextConfirm("");
      setSuccesText("비밀번호가 일치합니다.");
      setPasswordCrtf(true);
    }
  };

  const checkPasswordConfirm = () => {
    const newVal = newPassword.current!.value;
    const newValConfirm = newPasswordConfirm.current!.value;

    setNewValText("");
    if (isEmpty(newValConfirm)) {
      setNewValTextConfirm("새 비밀번호를 입력해 주세요.");
      setSuccesText("");
      setPasswordCrtf(false);
      return false;
    } else if (spaceCheck(newValConfirm)) {
      setNewValTextConfirm("새 비밀번호 앞뒤에 공백이 들어갈수 없습니다.");
      setSuccesText("");
      setPasswordCrtf(false);
      return false;
    } else if (!checkMixEngNum(newValConfirm) || newValConfirm.length < 8) {
      setNewValTextConfirm("영문, 숫자 포함 8글자 이상 입력해주세요.");
      setSuccesText("");
      setPasswordCrtf(false);
      return false;
    } else if (newVal != newValConfirm) {
      setNewValTextConfirm("새 비밀번호와 동일하지 않습니다.");
      setSuccesText("");
      setPasswordCrtf(false);
      return false;
    } else {
      setNewValText("");
      setNewValTextConfirm("");
      setSuccesText("비밀번호가 일치합니다.");
      setPasswordCrtf(true);
    }
  };

  const checkMixEngNum = (password: string) => {
    const num = password.search(/[0-9]/g);
    const eng = password.search(/[a-z]/gi);
    return num >= 0 && eng >= 0;
  };

  const handleClickConfirm = () => {
    const newVal = newPassword.current!.value;
    const data1: any = serializeObject({
      selector: ".device-ctrfcation-body.find-password",
      element: null,
    });
    callApi(
      "/cmap1010/execPwdUpd",
      { password: newVal, email: data1.email, mobile: data1.mobile },
      "POST"
    ).then((res) => {
      const msgVO = res.MsgVO;
      if (msgVO.msgCd === "CMAP1010-00") {
        dispatch({
          type: "POP_UP_OPEN",
          id: "FIND_PASSWORD_COMPLETE_POP",
          open: { findPasswordCompletePop: true },
        });
        setName(res.MobileMembersVO.name);
      }
    });
  };

  return (
    <>
      <div className="popup-body">
        <div className="device-ctrfcation find-password-pop">
          <div className="device-ctrfcation-body find-password">
            <Input
              title="비밀번호"
              name="password"
              type="password"
              placeholder="영문, 숫자 포함 8글자이상"
              onBlur={checkPassword}
              ref={newPassword}
              errorText={newValText}
            />
            <Input
              title="비밀번호 확인"
              name="passwordConfirm"
              type="password"
              placeholder="영문, 숫자 포함 8글자이상"
              onBlur={checkPasswordConfirm}
              ref={newPasswordConfirm}
              errorText={newValTextConfirm}
              succesText={succesText}
            />
          </div>
          <div className="device-ctrfcation-footer find-password">
            {passwordCrtf ? (
              <div className="btn active1" onClick={handleClickConfirm}>
                <div>비밀번호 재설정</div>
              </div>
            ) : (
              <div className="btn">
                <div>비밀번호 재설정</div>
              </div>
            )}
          </div>
        </div>
      </div>
      <FindPasswordCompletePop name={name} />
    </>
  );
}

export default ChangePasswordPop;
